module.exports = __webpack_public_path__ + "media/ru_ru_s4_Vova.e17a6ba7.mp3";